import amex from '../../../../../assets/img/about/logos/American-Express.svg';
import blockfolio from '../../../../../assets/img/about/logos/Blockfolio.svg';
import boeing from '../../../../../assets/img/about/logos/Boeing.svg';
import byteDance from '../../../../../assets/img/about/logos/ByteDance.svg';
import deloitte from '../../../../../assets/img/about/logos/Deloitte.svg';
import evite from '../../../../../assets/img/about/logos/Evite.svg';
import jpMorgan from '../../../../../assets/img/about/logos/JPMorgan.svg';
import microsoft from '../../../../../assets/img/about/logos/Microsoft.svg';
import nasa from '../../../../../assets/img/about/logos/NASA.svg';
import tradesy from '../../../../../assets/img/about/logos/Tradesy.svg';
import truecar from '../../../../../assets/img/about/logos/TrueCar.svg';
import ziprecruiter from '../../../../../assets/img/about/logos/ZipRecruiter.svg';
import Image from 'next/image';
import React from 'react';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import styles from './ExpertsFromSection.module.scss';

export const logos = [
    {
        src: amex,
        alt: 'American Express - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: blockfolio,
        alt: 'Blockfolio - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: boeing,
        alt: 'Boeing - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: byteDance,
        alt: 'ByteDance - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: deloitte,
        alt: 'Deloitte - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: evite,
        alt: 'Evite - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: jpMorgan,
        alt: 'JP Morgan Chase - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: microsoft,
        alt: 'Microsoft - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: nasa,
        alt: 'NASA - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: tradesy,
        alt: 'Tradesy - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: truecar,
        alt: 'TrueCar - Branding',
        height: 600,
        width: 704,
        id: 0
    },
    {
        src: ziprecruiter,
        alt: 'ZipRecruiter - Branding',
        height: 600,
        width: 704,
        id: 0
    }
];

export const ExpertsFromSection = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <div className={styles.Wrapper} ref={ref}>
            <div className={styles.ImgsWrapper}>
                <div className={`${styles.ImgContainer} ${runAnimation}`} id={`header`} key={`header`}>
                    <h2>Experts from:</h2>
                </div>
                {logos.map((data) => (
                    <div className={`${styles.ImgContainer} ${runAnimation}`} id={`${data.id}`} key={data.id}>
                        {data.src && (
                            <Image
                                src={data.src}
                                alt={data.alt}
                                width={data.width}
                                height={data.height}
                                loading={'lazy'}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
